"use client"

import styles from "./styles.module.scss";
import { useState } from "react";
import { usePathname } from "next/navigation";
import Drawer from "react-modern-drawer";
import { MENU_HEADER_STATIC } from "../../../../../setting/setting";
import { MenuTypeMobile } from "../../../../../veria-nextv1/MenuTypeMobile";
import { useCore } from "../../../../../core-nextv3/core/core";
import { useCustomPush } from "@/core-nextv3/util/util.use";

interface MenuProps {
  menu?: any,
  isOpen: boolean;
  closeMenu: () => void;
}

export const Menu = ({
    menu,
    isOpen,
    closeMenu,
}:MenuProps) => 
{
    const { user }    = useCore();
    const [ subMenu, setSubMenu ] = useState(false);
    const customPush = useCustomPush();
    const pathname   = usePathname();

    const doLogin = () =>
    {
        if (user)
        {
            customPush("/perfil/");
        }
        else
        {
            customPush("/login/");
        }		
    }

    // const handleOpenSubmenu = (e: BaseSyntheticEvent) => 
    // {
    //     if (e.target.parentElement.dataset.hasubmenu) 
    //     {
    //         e.target.parentElement.classList.toggle("open");
    //     }
    // };

    const regex = new RegExp("/produto");
    const regex2 = new RegExp("/colecoes/feed");

    return (
        isOpen && <Drawer
            open={isOpen}
            onClose={closeMenu}
            size="100%"
            direction="left"
            duration={300}
            className={styles.menuDrawer}
        >
            <section className={styles.menuContent}>
                {/* {pathname !== "/produtos" && (regex.test(pathname) || regex2.test(pathname)) && (
                    <GrClose
                        className={styles.closeModalProduct}
                        onClick={() => closeMenu()}
                    />
                )} */}

                <ul className="main">
                    <MenuTypeMobile menu={menu} closeMenu={closeMenu}/>
                    {/* {menu?.map((item: any, index: any) => (
          <li data-hasubmenu="true" key={index}>
            <small onClick={handleOpenSubmenu}>{item?.name}</small>
            <BsChevronRight />
            <ul className={styles.subMenu}>
              <li data-hasubmenu="true">
                <small onClick={handleOpenSubmenu}>All new</small>
                <BsChevronRight />
                <ul className={styles.subMenu}>
                  <li>
                    <small>All new</small>
                    <BsChevronRight />
                  </li>
                  <li>
                    <small>All new</small>
                    <BsChevronRight />
                  </li>
                  <li>
                    <small>All new</small>
                    <BsChevronRight />
                  </li>
                </ul>
              </li>
              <li>
                <small>Women</small>
                <BsChevronRight />
              </li>
              <li>
                <small>Man</small>
                <BsChevronRight />
              </li>
            </ul>
          </li>
          ))} */}
                    {/* <Accordion disableGutters className={styles.accordion}>
            <AccordionSummary expandIcon={<BsChevronRight />}>
              Coleção
            </AccordionSummary>
            <AccordionDetails>
              <section>
                <Image
                  src="/images/placeholder_product.webp"
                  loading="lazy"
                  width={1800}
                  height={2700}
                  alt="Produto"
                />
                <Image
                  src="/images/placeholder_product.webp"
                  loading="lazy"
                  width={1800}
                  height={2700}
                  alt="Produto"
                />
              </section>
            </AccordionDetails>
          </Accordion> */}
                    {/* <li>
            <small>Roupas</small>
            <BsChevronRight />
          </li>
          <li>
            <small>Promoção</small>
            <BsChevronRight />
          </li>
          <div className={styles.divider} />
          <li>
            <small>Blog</small>
          </li> */}

                    <div className={styles.divider} />
                    {MENU_HEADER_STATIC && MENU_HEADER_STATIC?.map(( menuItem: any, index:number ) => (
                        <li key={index}>
                            {menuItem?.children?.length > 0 ? 
                                <div className={styles.menuChild}>
                                    <small className={styles.titleChild} onClick={() => setSubMenu(!subMenu) }>{menuItem?.label}</small>
                                    {subMenu &&
                      <div className={styles.subMenuMobile}>
                          {menuItem?.children?.map((menuChild: any, index: any) => (
                              <small
                                  key={index}
                                  onClick={() => 
                                  {
                                      customPush(menuChild?.url); closeMenu() 
                                  }}
                              >
                                  {menuChild?.label}
                              </small>
                          ))}
                      </div>
                                    }
                                </div>
                                : 
                                (
                                    <small onClick={() => 
                                    {
                                        customPush(menuItem?.url); closeMenu() 
                                    }}>{menuItem?.label}</small>
                                )
                            }
                            {/* {menuItem?.children > 0 ? <small onClick={() => { setIsFaqOpen(true); setIsHeaderMenuOpen(false)}}>{menuItem?.label}</small> : <small>{menuItem?.label}</small> } */}
                        </li>  
                    ))}
                    {/* <li>
            <small>Sobre Nós</small>
          </li>
          <li>
            <small>Rastrear Pedidos</small>
          </li>
          <li>
            <small>Trocas e Devolução</small>
          </li>
          <li
            onClick={() => {
              setIsFaqOpen(true);
              setIsHeaderMenuOpen(false);
            }}
          >
            <small>Dúvidas</small>
          </li> */}
                </ul>
                <section className={styles.bottom}>
                    <button
                        onClick={() => 
                        {
                            closeMenu();
                            customPush("/");
                        }}
                    >Início</button>
                    <button
                        onClick={() => 
                        {
                            closeMenu();
                            doLogin();
                        }}
                    >Minha Conta</button>
                </section>
            </section>
        </Drawer>
    );
};
